import React, { useState, useEffect } from "react";

import { Image, StyleSheet, View } from "react-native";

import useCropperContext from "./context/cropper";
import { ImageCropOverlay } from "./ImageCropOverlay";
import { Dimensions } from "./types";

function EditingWindow() {
  const [imageLayout, setImageLayout] = useState<Dimensions | null>(null);
  const { imageData, setImageBounds, setImageScaleFactor, editingMode } =
    useCropperContext();
  const isCropping = editingMode === "crop";

  const onUpdateCropLayout = (layout: Dimensions | null) => {
    if (layout) {
      const editingWindowAspectRatio = layout.height / layout.width;
      const imageAspectRatio = imageData.height / imageData.width;
      const bounds = { x: 0, y: 0, width: 0, height: 0 };
      let imageScaleFactor = 1;
      if (imageAspectRatio > editingWindowAspectRatio) {
        bounds.x =
          (((imageAspectRatio - editingWindowAspectRatio) / imageAspectRatio) *
            layout.width) /
          2;
        bounds.width = layout.height / imageAspectRatio;
        bounds.height = layout.height;
        imageScaleFactor = imageData.height / layout.height;
      } else {
        bounds.y =
          (((1 / imageAspectRatio - 1 / editingWindowAspectRatio) /
            (1 / imageAspectRatio)) *
            layout.height) /
          2;
        bounds.width = layout.width;
        bounds.height = layout.width * imageAspectRatio;
        imageScaleFactor = imageData.width / layout.width;
      }
      setImageBounds(bounds);
      setImageScaleFactor(imageScaleFactor);
      setImageLayout({
        height: layout.height,
        width: layout.width,
      });
    }
  };

  useEffect(() => {
    onUpdateCropLayout(imageLayout);
  }, [imageData]);

  return (
    <View style={styles.container}>
      <Image
        style={styles.image}
        source={{ uri: imageData.uri }}
        onLayout={({ nativeEvent }) => onUpdateCropLayout(nativeEvent.layout)}
      />
      {isCropping && imageLayout != null && <ImageCropOverlay />}
    </View>
  );
}

export { EditingWindow };

const styles = StyleSheet.create({
  container: {
    flex: 1,
    margin: 16,
    position: "relative",
  },
  image: {
    flex: 1,
    resizeMode: "contain",
  },
});
